// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { lightTheme as defaultLightTheme, darkTheme as defaultDarkTheme } from '@azure/communication-react';
import { PartialTheme } from '@fluentui/react';

export const lightThemePalette: PartialTheme = {
  ...defaultLightTheme,
  semanticColors: {
    bodyBackground: 'rgb(250, 249, 248)'
  }
};

export const darkThemePalette: PartialTheme = {
  ...defaultDarkTheme,
  semanticColors: {
    bodyBackground: 'rgb(48, 46, 45)'
  }
};
